import { JSX } from 'react'

import styles from './InputDisabledWrapper.module.scss'

interface InputDisabledWrapper {
  children: JSX.Element
  disabled?: boolean
}

export const InputDisabledWrapper = ({ children, disabled }: InputDisabledWrapper) => {
  return <div className={disabled ? styles.root : ''}>{children}</div>
}
